import React from 'react';
import classnames from 'classnames';

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export default function LetterSelector({ tabList, activeLetter, onSelect }) {
    return (
        <div className="d-flex flex-row flex-wrap gap-1 py-1">
            {ALPHABET.map(letter => {
                const hasData = !!tabList[letter];
                return (
                    <button
                        key={letter}
                        onClick={() => hasData && onSelect(letter)}
                        disabled={!hasData}
                        className={classnames(
                            'btn btn-sm px-2 letter-btn',
                            { 'btn-dark': activeLetter === letter },
                            { 'has-data': activeLetter !== letter && hasData },
                            { 'letter-disabled': !hasData }
                        )}
                        style={{ minWidth: '32px' }}
                    >
                        {letter}
                    </button>
                );
            })}
        </div>
    );
}